let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
export const MediaTimelineHighlight = styledWithTheme.div(_t || (_t = _`
  position: absolute;
  left: calc(${0}% - 1px);
  width: calc(${0}% + 2px);
  height: 100%;
  background-color: ${0};
  opacity: 0.2;
`), ({
  startPosition
}) => startPosition, ({
  startPosition,
  endPosition
}) => endPosition - startPosition, ({
  theme
}) => theme.color['fill-accent-yellow-default']);